import React from 'react';
import { Box, Flex, Text } from '@mantine/core';

interface CompetitorListEmptyProps {
    isSearchResults: boolean;
}

export function CompetitorListEmpty({
    isSearchResults,
}: CompetitorListEmptyProps) {
    return (
        <Flex
            direction="column"
            align="center"
            justify="center"
            className="min-h-[280px] bg-white px-6 py-8"
        >
            <Box
                component="img"
                src="/illustrations/empty-list.png"
                alt=""
                className="h-[150px] w-auto max-w-full object-contain"
            />
            <Text
                ta="center"
                fw={600}
                size="lg"
                className="mt-[18px] max-w-[200px] leading-snug"
            >
                {isSearchResults
                    ? 'No Competitors Found'
                    : 'No Competitors for this Advertising Zone'}
            </Text>
            <Text
                ta="center"
                className="mt-1 max-w-[250px] text-[15px] leading-normal text-[#8F9BB3]"
            >
                {isSearchResults
                    ? 'No search results found.'
                    : 'There are no competitors for this advertising zone. Please add a competitor.'}
            </Text>
        </Flex>
    );
}
